import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface ICallViewContainerPresenter {
  call: Call;
}

export const useCallViewContainerPresenter = (): ICallViewContainerPresenter => {
  const context = useCallContext();

  return useLocalObservable<ICallViewContainerPresenter>(() => ({
    get call(): Call {
      return context.call;
    },
  }));
};
